import { NetworkError } from './requester.js';
/**
 * 给任意 AuthProvider 套上单飞语义。
 *
 * 并发的刷新请求共享同一次实际刷新,结果广播给所有等待者。
 */
export function singleFlightRefresh(provider) {
    let inflight = null;
    return {
        getHeaders: () => provider.getHeaders(),
        refresh: () => {
            inflight ??= provider.refresh().finally(() => {
                inflight = null;
            });
            return inflight;
        },
    };
}
/** 未登录时使用。刷新永远失败 —— 没有会话可刷 */
export const anonymousAuth = {
    getHeaders: () => Promise.resolve({}),
    refresh: () => Promise.resolve(false),
};
/**
 * 幂等键。
 *
 * ⚠ 为什么变更操作需要它:一次超时**不代表服务端没执行**。
 *   请求可能已经落库、只是响应没回来。因此传输层默认不重试写操作 ——
 *   但这让"会后录音提交"这类核心流程在弱网下很难受:用户说了两分钟,
 *   提交超时,只能重录。
 *
 *   幂等键让重试变得安全:同一个键的重复请求,服务端返回首次的结果
 *   而不再执行一遍。键由客户端生成并在重试间保持不变 ——
 *   每次重试换一个新键就完全失去了意义。
 */
export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';
export function generateIdempotencyKey(random = Math.random) {
    // 小程序运行时没有 crypto.randomUUID,用时间戳加随机段即可满足
    // "同一客户端不重复"的要求
    const rand = () => Math.floor(random() * 0x100000000).toString(36);
    return `${Date.now().toString(36)}-${rand()}-${rand()}`;
}
/** 请求耗尽总预算 */
export class DeadlineExceededError extends NetworkError {
    constructor(elapsedMs, budgetMs) {
        super('timeout', `请求总耗时 ${Math.round(elapsedMs)}ms,超过预算 ${budgetMs}ms`);
        this.name = 'DeadlineExceededError';
    }
}
//# sourceMappingURL=auth.js.map